import { MdDashboard } from "react-icons/md";
import { FaUsers, FaClipboardList, FaTasks, FaChartBar, FaCog, FaUserShield } from "react-icons/fa";

/*
 ⭐ ERP Navigation Structure
*/

export const sidebarMenu = [

  // ================= DASHBOARD =================
  {
    group: "General",
    items: [
      {
        name: "Dashboard",
        path: "/dashboard",
        icon: <MdDashboard size={20} />,
        color: "text-indigo-500",
      }
    ]
  },

  // ================= OPERATIONS =================
  {
    group: "Operations",
    items: [

      {
        name: "Clients",
        path: "/clients",
        icon: <FaUsers size={20} />,
        color: "text-emerald-500",
      },

      {
        name: "Assignments",
        path: "/assignments",
        icon: <FaClipboardList size={20} />,
        color: "text-purple-500",
      },

      {
        name: "Work / Tasks",
        path: "/tasks",
        icon: <FaTasks size={20} />,
        color: "text-amber-500",
      }

    ]
  },

  // ================= ANALYTICS =================
  {
    group: "Analytics",
    items: [
      {
        name: "Reports",
        path: "/reports",
        icon: <FaChartBar size={20} />,
        color: "text-blue-500",
      }
    ]
  },

  // ================= ADMINISTRATION =================
  {
    group: "Administration",
    items: [
      {
        name: "Administration",
        path: "/admin",
        icon: <FaUserShield size={20} />,
        color: "text-rose-500",
      }
    ]
  }

];
